import { Log } from '@lightningjs/sdk';
import { Backend } from '../../api/Backend';

export class DataSource {
  protected backend: Backend;
  protected titleHeight: number;
  constructor(backend: Backend) {
    this.backend = backend;
    this.titleHeight = 0;
  }

  /**
   * load the datasource
   */
  load(): Promise<DataSource> {
    Log.error('[DataSource] load method not overridden', this);
    return Promise.resolve(this);
  }

  /**
   * check if the datasource initial load contains data
   */
  isEmpty(): boolean {
    return false;
  }

  noData(): boolean {
    return false;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  componentDescription() {}

  /**
   * Combine ribbon and page properties
   */
  combineProperties(prop1: string[] | undefined, prop2: string[] | undefined): string[] {
    let result: string[] = [];
    if (prop1) {
      result = result.concat(prop1);
    }
    if (prop2) {
      result = result.concat(prop2);
    }
    return result;
  }
}
